"use client";
import { useState } from "react";
import { useSession } from "../../lib/session";
import { formatTime } from "../../lib/api";
import { DeskCard, Facts, Fact } from ".";
import { ReadState, useRead } from "./record-tools";
import { ContentConfirmedCommand } from "./content-confirmed-command";
type Profile = { version: number; updatedAt: string; snapshotValidAt: string; metrics: Array<{ label: string; value: number; caliber: string; validAt?: string; computedAt?: string; definitionVersion?: number }> };
export function PortalMetrics() {
  const { hasRole } = useSession();
  return hasRole("CHANNEL_PUBLISHER") ? <Metrics /> : null;
}
function Metrics() {
  const read = useRead<Profile>("/api/v1/portal-profile");
  const [result, setResult] = useState<Profile | null>(null);
  const profile = result ?? read.data;
  return <DeskCard title="门户名片数字" description="从已计算的公开指标快照更新，缺项时暂停刷新。">
    <ReadState {...read} retry={read.reload} />
    {result && <p role="status">门户名片数字已刷新，可核对下方时间与结果。</p>}
    {profile && <><p>上次刷新：{formatTime(profile.updatedAt)} · 统计时点：{profile.snapshotValidAt}</p><Facts>{profile.metrics.map((m) => <Fact key={m.label} label={m.label}><span>{m.value}</span><p>{m.caliber}</p><p>统计时点：{m.validAt ? formatTime(m.validAt) : "待核对"} · 计算时间：{m.computedAt ? formatTime(m.computedAt) : "待核对"} · 口径版本：{m.definitionVersion ?? "待核对"}</p></Fact>)}</Facts>
    <ContentConfirmedCommand<Profile> label="刷新门户名片数字" title="刷新门户名片数字？" consequence="核对四项公开指标快照并更新名片数字；快照未齐备时保持原结果。" path="/api/v1/portal-profile/refresh-metrics" body={{ expectedVersion: profile.version }} onSaved={(next) => setResult(next)} /></>}
  </DeskCard>;
}
